import React from 'react';
import {useDispatch} from 'react-redux';
import {useInput, useRemoveField, useToggleRequired} from '../../model';
import {setFields, setRequired} from '../../service/createForm.slice';
import {Input, RemoveButton, RequiredButton} from '../../ui';
import {InputIcon} from '../../icons';
import {useLocation} from 'react-router-dom';
import {useTranslation} from '../../../../hooks/useTranslation';
function InputField({field, idx}) {
  const dispatch = useDispatch();
  const form_title = useInput('');
  const {removeField} = useRemoveField();
  const {toggleRequired} = useToggleRequired();
  const location = useLocation();
  let isReadOnly = Boolean(location.search.split('=')[1]);
  const {t} = useTranslation();
  const handleChange = e => {
    form_title.handleChange(e);
    dispatch(
      setFields({
        index: idx,
        key: 'label',
        value: e.target.value,
      }),
    );
  };

  const handleRemove = () => removeField(idx);
  const handleRequired = () => toggleRequired(idx);

  return (
    <div className='f-build__general'>
      <div className='f-build__general-header'>
        <Input
          onChange={handleChange}
          label={t('createNewForm.components.fieldName')}
          placeholder={t('createNewForm.components.enterFieldName')}
          value={field.label}
          disabled={isReadOnly ? true : false}
        />
        {!isReadOnly && (
          <div className='f-build__general-actions'>
            <RequiredButton
              key={'input-required'}
              idx={idx}
              id={'input-required'}
              required={field?.required}
              handleRequired={handleRequired}
            />
            <RemoveButton
              key={'input-remove'}
              idx={idx}
              id={'input'}
              handleRemove={handleRemove}
            />
          </div>
        )}
      </div>
      <div className='f-build__general-type'>
        <InputIcon />
        <span>{t('createNewForm.components.inputField')}</span>
      </div>
    </div>
  );
}

export default InputField;
